import {
  FETCH_EXCEPTION_QUEUE,
  FETCH_EXCEPTION_QUEUE_ERROR,
  FETCH_EXCEPTION_QUEUE_SUCCESS,
  FETCH_GRADUATION_QUEUE,
  FETCH_GRADUATION_QUEUE_ERROR,
  FETCH_GRADUATION_QUEUE_SUCCESS,
  REVIEW_ACTION,
  REVIEW_ACTION_DONE,
} from './types';

const initialState = {
  exceptions: [],
  exceptionsLoading: false,
  exceptionsError: false,
  graduation: [],
  graduationLoading: false,
  graduationError: false,
  acting: false,
};

const degreePlanningReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXCEPTION_QUEUE:
      return { ...state, exceptionsLoading: true, exceptionsError: false };
    case FETCH_EXCEPTION_QUEUE_SUCCESS:
      return { ...state, exceptionsLoading: false, exceptions: action.payload };
    case FETCH_EXCEPTION_QUEUE_ERROR:
      return { ...state, exceptionsLoading: false, exceptionsError: true };
    case FETCH_GRADUATION_QUEUE:
      return { ...state, graduationLoading: true, graduationError: false };
    case FETCH_GRADUATION_QUEUE_SUCCESS:
      return { ...state, graduationLoading: false, graduation: action.payload };
    case FETCH_GRADUATION_QUEUE_ERROR:
      return { ...state, graduationLoading: false, graduationError: true };
    case REVIEW_ACTION:
      return { ...state, acting: true };
    case REVIEW_ACTION_DONE:
      return { ...state, acting: false };
    default:
      return state;
  }
};

export default degreePlanningReviewReducer;
